import { useTranslation } from "react-i18next";
import { Link } from "@mui/material";
import { MYACCOUNT_URL } from "@constants";

interface IParams {
    isFullInstall?: boolean;
}

export const DateChange = (props: IParams) => {
    const { isFullInstall } = props;
    const { t } = useTranslation("confirmation");

    return (
        <>
            {isFullInstall ? t("dateChangeFullInstall") : t("dateChangeNoInstall")}
            <Link color="primary" href={`${MYACCOUNT_URL}`} rel="noopener" target="_blank" underline="always">
                {t("myGomoAccount")}.
            </Link>
        </>
    );
};
